import * as React from 'react';
import * as classNames from 'classnames';

export interface BaseButtonState {
  pressed: boolean;
  hovered: boolean;
}

interface BaseButtonProps {
  readonly render?: (state: BaseButtonState) => JSX.Element;
  readonly onClick?: () => void;
  readonly href?: string;
  readonly title?: string;
  readonly ariaLabel?: string;
  readonly active?: boolean;
  readonly disabled?: boolean;
}

class BaseButton extends React.PureComponent<BaseButtonProps, BaseButtonState> {
  public constructor(props: BaseButtonProps) {
    super(props);

    this.state = {
      pressed: false,
      hovered: false,
    };
  }

  private handlePointerDown = () => {
    if (this.props.disabled) {
      return;
    }

    this.setState({ pressed: true });
  }

  private handlePointerUp = () => {
    this.setState({ pressed: false, hovered: false });
  }

  private handleMouseEnter = () => {
    if (this.props.disabled) {
      return;
    }

    this.setState({ hovered: true });
  }

  private handleMouseLeave = () => {
    this.setState({ hovered: false });
  }

  private handleClick = () => {
    const { onClick, disabled } = this.props;

    if (!disabled && onClick !== undefined) {
      onClick();
    }
  }

  public render() {
    const { render, href, title, ariaLabel, disabled, active } = this.props;

    const className = classNames({
      disabled: disabled === true,
      active: active === true,
    });

    return (
      <a
        href={href}
        style={{ WebkitTapHighlightColor: 'transparent' }}
        onClick={this.handleClick}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onMouseDown={this.handlePointerDown}
        onTouchStart={this.handlePointerDown}
        onPointerDown={this.handlePointerDown}
        onMouseUp={this.handlePointerUp}
        onTouchEnd={this.handlePointerUp}
        onPointerUp={this.handlePointerUp}
        onMouseOut={this.handlePointerUp}
        onTouchCancel={this.handlePointerUp}
        onPointerCancel={this.handlePointerUp}
        onPointerOut={this.handlePointerUp}
        onMouseMove={this.handlePointerUp}
        onTouchMove={this.handlePointerUp}
        onPointerMove={this.handlePointerUp}
        title={title}
        aria-label={ariaLabel}
        className={className}>
        {render ? render(this.state) : null}
      </a>
    );
  }
}

export default BaseButton;
